var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangepasswordDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.46,
    height: 18.326,
    viewBox: "0 0 18.46 18.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_Password",
    "data-name": "Change Password",
    transform: "translate(-0.687 -1.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1208",
    "data-name": "Rectangle 1208",
    width: 18,
    height: 18,
    transform: "translate(0.97 1.02)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 0.471,
    cy: 0.471,
    r: 0.471,
    transform: "translate(15.993 4.862)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293",
    transform: "translate(6.796 6.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    d: "M13.484,9.9V8.382A1.763,1.763,0,0,0,11.5,7.109,1.665,1.665,0,0,0,9.79,8.382V9.9",
    transform: "translate(-8.327 -7.106)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1208-2",
    "data-name": "Rectangle_1208",
    d: "M8.656,11.02h5.338a.583.583,0,0,1,.636.5v3.867a.578.578,0,0,1-.636.5H8.656a.583.583,0,0,1-.636-.5V11.524a.578.578,0,0,1,.636-.5Z",
    transform: "translate(-8.02 -7.786)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    d: "M1.66,4.95l2.859-.43.43,2.859",
    transform: "translate(-0.12 -0.608)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    d: "M17.338,4.112a8.522,8.522,0,0,0-1.215-.835A8.293,8.293,0,0,0,12.43,2.22",
    transform: "translate(-1.99 -0.208)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170-2",
    d: "M3.767,5.89,3.015,7.072a8.281,8.281,0,1,0,14.808.752",
    transform: "translate(-0.17 -0.846)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepasswordDarkIcon);
export default __webpack_public_path__ + "static/media/changepassword-dark-icon.2462e95aa5eacf92f6b574c783820335.svg";
export { ForwardRef as ReactComponent };